var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.formContext.isLoaded
    ? _c(
        "csp-desktop-info-card",
        {
          key: _vm.formContext.isInEditMode,
          attrs: {
            cols: 12,
            "form-context": _vm.formContext,
            icon: "inticon-users",
            title: "Anspruchsteller (Versicherer)",
          },
          on: { save: _vm.saveClaimantFormData },
          scopedSlots: _vm._u(
            [
              _vm.formContext.permissions.canCreateRetroactiveChangesNote ===
              true
                ? {
                    key: "after-icons",
                    fn: function () {
                      return [
                        _c("csp-retroactive-changes-modal", {
                          attrs: {
                            "record-id": _vm.recordId,
                            title: "Anspruchsteller (Versicherer)",
                          },
                        }),
                      ]
                    },
                    proxy: true,
                  }
                : null,
            ],
            null,
            true
          ),
        },
        [
          _vm._v(" "),
          _vm.showChangelogButton
            ? _c(
                "div",
                { staticClass: "float-right" },
                [
                  _c("csp-changelog-modal", {
                    attrs: { "changelog-url": _vm.claimantChangelogUrl },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("h2", [_vm._v("Stammdaten")]),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Anrede",
                  property: "gender",
                  type: "radio",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Ansprechpartner Titel",
                  property: "title",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Ansprechpartner Vorname",
                  property: "firstName",
                  type: "text",
                },
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Ansprechpartner Nachname",
                  property: "lastName",
                  type: "text",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("h2", { staticClass: "float-left" }, [
            _vm._v("\n        Versicherungsdaten\n    "),
          ]),
          _vm._v(" "),
          _vm.showChangelogButton
            ? _c(
                "div",
                { staticClass: "float-right" },
                [
                  _c("csp-changelog-modal", {
                    attrs: {
                      "changelog-url": _vm.claimantInsuranceChangelogUrl,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "clear-float" }),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                staticClass: "col-3",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Schadensnummer-Haftpflicht",
                  property: "adversaryInsuranceReference",
                  type: "text",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c("csp-desktop-info-card-element", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.shouldDisplayInsuranceParent,
                    expression: "shouldDisplayInsuranceParent",
                  },
                ],
                staticClass: "col-6",
                attrs: {
                  "form-context": _vm.formContext,
                  label: "Versicherungskonzern",
                  "options-loader": _vm.loadInsuranceParentOptions,
                  property: "insuranceParent",
                  type: "autocomplete",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "display-value",
                      fn: function () {
                        return [
                          _vm.formContext.data.insuranceName
                            ? _c("span", [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.formContext.data.insuranceName)
                                  ),
                                ]),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formContext.data.insurancePhone
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.formContext.data.insurancePhone)
                                ),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formContext.data.insuranceEmail
                            ? _c("span", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        "mailto:" +
                                        _vm.formContext.data.insuranceEmail,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.formContext.data.insuranceEmail
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4147792178
                ),
              }),
              _vm._v(" "),
              _c("csp-desktop-info-card-element", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.shouldDisplayInsuranceBranch,
                    expression: "shouldDisplayInsuranceBranch",
                  },
                ],
                staticClass: "col-6",
                attrs: {
                  dependencies: ["insuranceParent"],
                  "form-context": _vm.formContext,
                  label: "Versicherungsfiliale",
                  "options-loader": _vm.loadInsuranceBranchOptions,
                  property: "insuranceBranch",
                  type: "autocomplete",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "display-value",
                      fn: function () {
                        return [
                          _vm.formContext.data.insuranceName
                            ? _c("span", [
                                _c("b", [
                                  _vm._v(
                                    _vm._s(_vm.formContext.data.insuranceName)
                                  ),
                                ]),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formContext.data.insurancePhone
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.formContext.data.insurancePhone)
                                ),
                                _c("br"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.formContext.data.insuranceEmail
                            ? _c("span", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href:
                                        "mailto:" +
                                        _vm.formContext.data.insuranceEmail,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(
                                          _vm.formContext.data.insuranceEmail
                                        ) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4147792178
                ),
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }